import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './dialog-upload-image.html';
import { EventAggregator } from "aurelia";
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import { AttributeInstance } from "../../../../mmar-global-data-structure";
import { bindable } from "aurelia";
import { VizrepUpdateChecker } from "resources/services/vizrep_update_checker";

@customElement(__au2ViewDef)
export class DialogUploadImage {
    private uppy: Uppy;
    @bindable private attributeInstance: AttributeInstance
    @bindable private firstLevel: boolean = null;

    constructor(
        private eventAggregator: EventAggregator,
        private vizrepUpdateChecker: VizrepUpdateChecker
    ) {
    }

    async attached() {
        //init uppy dashboard
        //only allow image files
        this.uppy = new Uppy(
            {
                restrictions: {
                    allowedFileTypes: ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp', '.bmp', '.tiff']
                }
            }
        );

        //bind dashboard to the dragdrop element
        //if first level, bind to the first dragdrop element
        //if second level, bind to the second dragdrop element
        // we have to do this because the dragdrop element would be rendered twice otherwise
        if (this.firstLevel)
            this.uppy.use(Dashboard, { inline: true, target: '#imagedragdropfirstlevel', hideUploadButton: true, showProgressDetails: true, width: '100%', height: '200px' });
        else {
            this.uppy.use(Dashboard, { inline: true, target: '#imagedragdropsecondlevel', hideUploadButton: true, showProgressDetails: true, width: '100%', height: '200px' });
        }
    }

    load() {
        const files = this.uppy.getFiles();
        const reader = new FileReader();

        if (files) {
            for (const file of files) {
                //read the file -> trigger the event listener
                reader.readAsDataURL(file.data);
                //remove the file from the uppy dashboard
                this.uppy.removeFile(file.id)
            }
            //timeout to wait for the files to be read
            setTimeout(async () => {
                //publish the event to update the scene group
                this.eventAggregator.publish('imageUploaded', this.attributeInstance);
            }, 1000);
        }

        //event listener for when the file is loaded
        reader.addEventListener(
            "load",
            async () => {
                //when a file is loaded, convert it to base64 string
                const result = reader.result;
                //remove the string 'data:*/*;base64' from the string
                // const string = result.toString().replace(/^data:image\/[a-z]+;base64,/, "");
                this.attributeInstance.value = result.toString();
                
                await this.vizrepUpdateChecker.checkForVizRepUpdate(this.attributeInstance);
            },
            { passive: true }
        );
    }
}
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = DialogUploadImage;

    // @ts-ignore
    const proto = DialogUploadImage.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }